import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "./Components/Access";
import Navbar from "./Components/Navbar";
import BilanOperations from "./BilanOperations/BilanOperations";
import { addSpace, rescueHtml } from "./Components/Tools";
import { ReactComponent as IconPdfWhite } from './Img/icon-pdf-white.svg';


/*
    La variable ListeOperations contient toutes les infos de l'opération et est structurée ainsi:
    operation.id  = id
    operation.id_budget = id_budget
    operation.numero_inventaire = numero_inventaire
    operation.nom = nom
    operation.montant = montant
    operation.description = description
    operation.nom_client = nom_client (joint)
    operation.nom_modalite = nom_modalite (joint)
    operation.nom_axe = nom_axe (joint)
    ... et toutes les autres colonnes de la table operations
*/


const OperationsListing = (props) =>
{
    const [listeOperations, setListeOperations] = useState([]);
    const [aff, setAff] = useState(false);
    const [buttonVisible, setButtonVisible] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');
    const [selectedList, setSelectedList] = useState([]);
    const [modalites, setModalites] = useState([]);
    const [axes, setAxes] = useState([]);
    const [territoires, setTerritoires] = useState([]);
    const [clients, setClients] = useState([]);
    const [modaliteFilter, setModaliteFilter] = useState('');
    const [axeFilter, setAxeFilter] = useState('');
    const [territoireFilter, setTerritoireFilter] = useState('');
    const [clientFilter, setClientFilter] = useState('');
    const [searchText, setSearchText] = useState('');
    const [searchNumero, setSearchNumero] = useState('');
    
    const purple = '#6571FE';

    async function mount() {
        const params = {
            'get': true,
            'id_budget': props.user.id_budget
        }
        await axios.post('https://app-slfinance.fr/api/operations.php', qs.stringify(params))
        .then((result) => {
            if (result.data.data) {
                setListeOperations(result.data.data);
            }
        })
        .catch((err) => {
            console.warn(err)
        })

        // modalites (pour filtre)
        try {
            const rm = await axios.post('https://app-slfinance.fr/api/modalites_portage.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rm && rm.data) setModalites(Array.isArray(rm.data) ? rm.data : (rm.data.data ? rm.data.data : []));
            else setModalites([]);
        } catch (err) {
            console.warn(err);
            setModalites([]);
        }

        // axes d'interventions
        try {
            const ra = await axios.post('https://app-slfinance.fr/api/axes_interventions.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (ra && ra.data) setAxes(Array.isArray(ra.data) ? ra.data : (ra.data.data ? ra.data.data : []));
            else setAxes([]);
        } catch (err) {
            console.warn(err);
            setAxes([]);
        }

        // territoires
        try {
            const rt = await axios.post('https://app-slfinance.fr/api/territoires.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rt && rt.data) setTerritoires(Array.isArray(rt.data) ? rt.data : (rt.data.data ? rt.data.data : []));
            else setTerritoires([]);
        } catch (err) {
            console.warn(err);
            setTerritoires([]);
        }

        // clients
        try {
            const rc = await axios.post('https://app-slfinance.fr/api/clients_epfl.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rc && rc.data) setClients(Array.isArray(rc.data) ? rc.data : (rc.data.data ? rc.data.data : []));
            else setClients([]);
        } catch (err) {
            console.warn(err);
            setClients([]);
        }
    }

    
    const sortBy = (field) => {
        let newOrder = 'asc';
        if (sortField === field && sortOrder === 'asc') {
            newOrder = 'desc';
        }
        setSortField(field);
        setSortOrder(newOrder);
        
        setListeOperations(prev => {
            const copy = Array.isArray(prev) ? [...prev] : [];
            copy.sort((a, b) => {
                const va = a && a[field] !== undefined && a[field] !== null ? a[field] : '';
                const vb = b && b[field] !== undefined && b[field] !== null ? b[field] : '';
                
                let comparison = 0;
                if (field === 'numero_inventaire') {
                    comparison = parseInt(va || 0) - parseInt(vb || 0);
                } else {
                    comparison = ('' + va).toString().localeCompare(('' + vb).toString());
                }
                
                return newOrder === 'asc' ? comparison : -comparison;
            });
            return copy;
        });
        setAff(!aff);
    };

    
    async function allOrNoneChecked(list) {
        if (list.length === 0) {
            return 'liste vide';
        }
        
        const firstState = list[0]['checked'];
        
        for (let i = 1; i < list.length; i++) {
            if (list[i]['checked'] !== firstState) {
                return 'pas uniforme';
            }
        }
        return list[0]['checked'];
    }
    

    
    async function checkifitsok(list)
    {
        var ret = false
        for (let i = 0; i < list.length; i++) {
            if (list[i]['checked'] === true) {
                ret = true;
            }
        }
        await setButtonVisible(ret);

        await allOrNoneChecked(list)
        .then((response) => {
            if (response === true || response === false) {
                setIsChecked(response)
            }
            if (response === 'pas uniforme' && isChecked === true) {
                setIsChecked(false);
            }
        })
        await setAff(!aff);
    }


    async function setCheck(list, id)
    {
        const newList = list.map(op => 
            op.id === id ? {...op, checked: !op.checked} : op
        );
        await setListeOperations(newList);
        await checkifitsok(newList);
    }

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const filtered = listeOperations.filter(op => {
        // Filtre modalité
        if (modaliteFilter && modaliteFilter !== '') {
            if (String(op.id_modalite_portage) !== String(modaliteFilter)) return false;
        }
        // Filtre axe d'intervention
        if (axeFilter && axeFilter !== '') {
            if (String(op.id_axes_interventions) !== String(axeFilter)) return false;
        }
        // Filtre territoire
        if (territoireFilter && territoireFilter !== '') {
            if (String(op.id_territoires) !== String(territoireFilter)) return false;
        }
        // Filtre client
        if (clientFilter && clientFilter !== '') {
            if (String(op.id_clients_epfl) !== String(clientFilter)) return false;
        }
        // Filtre recherche nom (insensible aux accents)
        if (searchText && searchText.trim() !== '') {
            const search = removeAccents(searchText.toLowerCase());
            const nom = removeAccents((op.nom || '').toLowerCase());
            if (!nom.includes(search)) return false;
        }
        // Filtre recherche numéro
        if (searchNumero && searchNumero.trim() !== '') {
            const numero = (op.numero_inventaire || '').toLowerCase();
            if (!numero.includes(searchNumero.toLowerCase())) return false;
        }
        return true;
    });

    // Récuperation de la liste des opérations
    useEffect(() => {
        if (props.user === null) {
            props.getUser()
        }
        else {
            mount();
        }
    }, [props.user])


	return (
        <div>
            <Access needConnection={true} type_user={[0]}>
                <Navbar user={props.user} />

                <div style={{display: 'flex'}}>
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        
                        <div style={{flex: 1, display: 'flex'}}>
                            <p>Opérations</p>
                            <p style={{marginLeft: 5}}>\</p>
                            <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>Édition des opérations</p>
                        </div>

                        {selectedList.length == 0?
                        <div style={{flex: 1}}>
                            {props.user?
                            <p style={{flex: 1, textAlign: 'center'}}>{props.user.nom_budget}</p>
                            :null}
                        </div>
                        :null}

                        <div style={{flex: 1}}></div>
                    </div>
                </div>

                {selectedList.length == 0?
                    buttonVisible?
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        <div style={{flex: 1}}></div>
                        <button
                            className='shadow-md rounded-md'
                            style={{backgroundColor: purple, color: 'white', fontSize: 17, alignItems: 'center', justifyContent: 'center', display: 'flex', paddingLeft: 10, paddingRight: 10}}
                            onClick={async () => {
                                var list_tmp = [];
                                for (let i = 0; i < filtered.length; i++) {
                                    if (filtered[i]['checked'] === true) {
                                        await list_tmp.push(filtered[i]);
                                    }
                                }
                                console.log(list_tmp);
                                await setSelectedList(list_tmp);
                                await setAff(!aff);
                            }}
                        >
                            <IconPdfWhite width="18"/>
                            <p style={{marginLeft: 10}}>Valider la liste</p>
                        </button>
                        <div style={{flex: 1}}></div>
                    </div>
                    :
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        <div style={{flex: 1}}></div>
                        <button
                            className='shadow-md rounded-md'
                            style={{backgroundColor: 'white', color: 'red', border: '1px solid red', borderRadius: 5, fontSize: 17, alignItems: 'center', justifyContent: 'center', display: 'flex', paddingLeft: 10, paddingRight: 10}}
                        >
                            <IconPdfWhite width="18"/>
                            <p style={{marginRight: 20}}>Sélectionnez les opérations que vous souhaitez insérer dans le PDF</p>
                        </button>
                        <div style={{flex: 1}}></div>
                    </div>
                :null}

                {selectedList.length == 0?
                <>
                <div style={{margin: '0 25px 25px 25px', padding: 20, backgroundColor: '#f8f9fa', borderRadius: 8, border: '1px solid #e0e0e0'}}>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: 15}}>
                        <p style={{fontSize: 16, fontWeight: 600, color: '#333', margin: 0}}>Filtres</p>
                        <div style={{flex: 1}}></div>
                        <button
                            className='shadow-sm'
                            style={{
                                padding: '8px 16px',
                                borderRadius: 4,
                                border: '1px solid #ccc',
                                backgroundColor: 'white',
                                fontSize: 13,
                                cursor: 'pointer',
                                color: '#666',
                                transition: 'all 0.2s'
                            }}
                            onClick={() => {
                                setSearchNumero('');
                                setSearchText('');
                                setClientFilter('');
                                setAxeFilter('');
                                setTerritoireFilter('');
                                setModaliteFilter('');
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f0f0f0';
                                e.currentTarget.style.borderColor = '#999';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.borderColor = '#ccc';
                            }}
                        >
                            Réinitialiser les filtres
                        </button>
                    </div>
                    
                    <div style={{display: 'flex', gap: 15, marginBottom: 15}}>
                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Rechercher par numéro</p>
                            <input
                                type="text"
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                                placeholder="Numéro d'inventaire..."
                                value={searchNumero}
                                onChange={e => setSearchNumero(e.target.value)}
                            />
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Rechercher par nom</p>
                            <input
                                type="text"
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                                placeholder="Nom de l'opération..."
                                value={searchText}
                                onChange={e => setSearchText(e.target.value)}
                            />
                        </div>
                    </div>

                    <div style={{display: 'flex', gap: 15}}>
                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Collectivités</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={clientFilter}
                                onChange={e => setClientFilter(e.target.value)}
                            >
                                <option value=''>Liste des collectivités</option>
                                {clients.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nom}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Axe d'intervention</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={axeFilter}
                                onChange={e => setAxeFilter(e.target.value)}
                            >
                                <option value=''>Tous les axes</option>
                                {axes.map((a) => (
                                    <option key={a.id} value={a.id}>{a.intitule}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Territoires</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={territoireFilter}
                                onChange={e => setTerritoireFilter(e.target.value)}
                            >
                                <option value=''>Tous les territoires</option>
                                {territoires.map((t) => (
                                    <option key={t.id} value={t.id}>{t.intitule}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Modalité de portage</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={modaliteFilter}
                                onChange={e => setModaliteFilter(e.target.value)}
                            >
                                <option value=''>Toutes les modalités</option>
                                {modalites.map((m) => (
                                    <option key={m.id} value={m.id}>{m.nom}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                </>
                :null}

                {selectedList.length == 0?
                <div style={{flex: 1, textAlign: 'center'}}>

                    <div style={{flex: 1, display: 'flex'}}>

                        <div style={{flex: 1, margin: 15}}>
                            <div style={{display: 'flex', marginTop: 15, marginRight: 15}}>
                                <div style={{flex: 1}}></div>
                                <p style={{flex: 0.1}}>Opérations</p>
                            </div>

                            <div style={{display: 'flex', padding: '8px 12px', borderBottom: '1px solid #ddd', alignItems: 'center', fontWeight: 600, color: '#333'}}>
                                <div style={{width:30, marginLeft: 10, textAlign:'center'}}>
                                    <input
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={async() => {
                                            await setIsChecked(!isChecked);
                                            for (let i = 0; i < listeOperations.length; i++) {
                                                listeOperations[i]['checked'] = !isChecked?true:false;
                                            }
                                            await setListeOperations(listeOperations);
                                            await checkifitsok(listeOperations);
                                            await setAff(!aff);
                                        }}
                                    />
                                </div>

                                <div style={{width:50, textAlign:'center', cursor:'pointer'}}>
                                    <button
                                    style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 'inherit', textAlign: 'center', width: '100%'}}
                                    onClick={() => sortBy('color')}
                                    >
                                        <p style={{margin: 0}}>État {sortField === 'color' && (sortOrder === 'asc' ? '▲' : '▼')}</p>
                                    </button>
                                </div>
                                
                                <div style={{flex:1.5, minWidth:120, cursor:'pointer'}}>
                                    <button
                                    style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 'inherit', textAlign: 'left', width: '100%'}}
                                    onClick={() => sortBy('numero_inventaire')}
                                    >
                                        <p style={{margin: 0}}>Numéro {sortField === 'numero_inventaire' && (sortOrder === 'asc' ? '▲' : '▼')}</p>
                                    </button>
                                </div>

                                <div style={{flex:2.5, minWidth:0, cursor:'pointer'}}>
                                    <button
                                    style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 'inherit', textAlign: 'left', width: '100%'}}
                                    onClick={() => sortBy('nom')}
                                    >
                                        <p style={{margin: 0}}>Intitulé {sortField === 'nom' && (sortOrder === 'asc' ? '▲' : '▼')}</p>
                                    </button>
                                </div>

                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}}>
                                    <button
                                    style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 'inherit', textAlign: 'center', width: '100%'}}
                                    onClick={() => sortBy('nom_client')}
                                    >
                                        <p style={{margin: 0}}>Collectivités {sortField === 'nom_client' && (sortOrder === 'asc' ? '▲' : '▼')}</p>
                                    </button>
                                </div>

                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}}>
                                    <button
                                    style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 'inherit', textAlign: 'center', width: '100%'}}
                                    onClick={() => sortBy('nom_axe')}
                                    >
                                        <p style={{margin: 0}}>Axe d'intervention {sortField === 'nom_axe' && (sortOrder === 'asc' ? '▲' : '▼')}</p>
                                    </button>
                                </div>

                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}}>
                                    <button
                                    style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 'inherit', textAlign: 'center', width: '100%'}}
                                    onClick={() => sortBy('nom_territoire')}
                                    >
                                        <p style={{margin: 0}}>Territoires {sortField === 'nom_territoire' && (sortOrder === 'asc' ? '▲' : '▼')}</p>
                                    </button>
                                </div>

                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}}>
                                    <button
                                    style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 'inherit', textAlign: 'center', width: '100%'}}
                                    onClick={() => sortBy('nom_modalite')}
                                    >
                                        <p style={{margin: 0}}>Modalités de portage {sortField === 'nom_modalite' && (sortOrder === 'asc' ? '▲' : '▼')}</p>
                                    </button>
                                </div>

                                <div style={{width: 90}}>
                                    <div>Hypothèses</div>
                                    <div style={{display:'flex', justifyContent:'space-between', fontSize:12, fontWeight:600}}>
                                        <div style={{width:30, textAlign:'center'}}>H1</div>
                                        <div style={{width:30, textAlign:'center'}}>H2</div>
                                        <div style={{width:30, textAlign:'center'}}>H3</div>
                                    </div>
                                </div>
                            </div>

                            {filtered.map((operation, i) =>
                            <div className='shadow-xl rounded-sm' key={i} style={{display: 'flex', margin: 10, backgroundColor: '#ffffff', padding: '12px', borderRadius: 6, border: '1px solid #eee', alignItems: 'center', cursor: 'pointer'}} onClick={() => setCheck(listeOperations, operation.id)}>
                                <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                    <input
                                        type="checkbox"
                                        checked={operation['checked']}
                                        onChange={async () => {
                                            await setCheck(listeOperations, operation.id);
                                        }}
                                    />
                                </div>

                                <div style={{width:50, textAlign:'center'}}>
                                    <div style={{
                                        width: 16,
                                        height: 16,
                                        borderRadius: '50%',
                                        backgroundColor: (operation.color && operation.color !== '') ? operation.color : '',
                                        margin: '0 auto'
                                    }}></div>
                                </div>

                                <div style={{flex: 1.5, textAlign:'left', minWidth:120, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                    {rescueHtml(operation.numero_inventaire)}
                                </div>

                                <div style={{flex: 2.5, textAlign:'left', minWidth:0, fontSize: 14, fontWeight: 'bold'}}>
                                    {rescueHtml(operation.nom)}
                                </div>

                                <div style={{flex:2, textAlign:'center', fontSize: 12}}>
                                    {operation.nom_client || ''}
                                </div>

                                <div style={{flex:2, textAlign:'center', fontSize: 12}}>
                                    {operation.nom_axe || ''}
                                </div>

                                <div style={{flex:2, textAlign:'center', fontSize: 12}}>
                                    {operation.nom_territoire || ''}
                                </div>

                                <div style={{flex:2, textAlign:'center', fontSize: 12}}>
                                    {operation.nom_modalite || ''}
                                </div>

                                <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                    <input disabled={true} type="checkbox" checked={operation.h1 === "0"?false:true} />
                                </div>

                                <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                    <input disabled={true} type="checkbox" checked={operation.h2 === "0"?false:true} />
                                </div>

                                <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                    <input disabled={true} type="checkbox" checked={operation.h3 === "0"?false:true} />
                                </div>
                            </div>
                            )}
                        </div>

                    </div>
                </div>
                :
                <BilanOperations user={props.user} operations={selectedList}/>
                }
            </Access>
        </div>
	);
}

export default OperationsListing;
